import { CHANNEL, FEATURED_VIDEO, LONG_VIDEOS, TOP_SHORTS, formatViewsAr, onThumbLoad, thumbRef, thumbUrl, type HomeVideo } from "@/data/home-videos";
import { VideoCard } from "@/components/home/video-card";
import { useVideoPlayer } from "@/components/home/video-player";

const link = "inline-flex min-h-11 items-center font-display text-[15px] font-bold text-text-link underline-offset-4 hover:underline";

export function HomeVideosSection() {
  return (
    <div id="videos" className="reveal mx-auto max-w-[76rem] py-14 lg:py-20">
      <div className="px-5">
        <p className="font-display text-[13px] font-bold text-amber-800">من قناة د. سارة</p>
        <h2 className="mt-2 font-display text-[30px] font-extrabold text-maroon-500 lg:text-[36px]">
          دقيقة وحدة ممكن <span className="mark whitespace-nowrap">تغيّر يومك</span>
        </h2>
        <p className="mt-3 flex flex-wrap items-center gap-x-3 text-[15px] text-text-secondary">
          <span><bdi dir="ltr">{Math.round(CHANNEL.subscribers / 1000)}</bdi> ألف مشترك</span>
          <span aria-hidden>·</span>
          <span><bdi dir="ltr">{CHANNEL.videos}</bdi> فيديو</span>
          <span aria-hidden>·</span>
          <a href={CHANNEL.url} target="_blank" rel="noopener noreferrer" className={link}>القناة على يوتيوب ←</a>
        </p>
      </div>

      <div className="mt-8 flex flex-col gap-10">
        <div className="order-2 grid gap-5 px-5 lg:order-1 lg:grid-cols-[minmax(0,1.4fr)_minmax(0,1fr)]">
          <VideoCard
            video={FEATURED_VIDEO}
            label={`حلقة جديدة · ${FEATURED_VIDEO.duration}`}
            className="aspect-video w-full"
            titleSize="text-[18px] lg:text-[24px]"
          />
          <ul className="flex flex-col gap-3">
            {LONG_VIDEOS.map((v) => (
              <li key={v.id}><LongRow video={v} /></li>
            ))}
          </ul>
        </div>

        <div className="order-1 lg:order-2">
          <div className="flex items-end justify-between gap-4 px-5">
            <p className="font-display text-[19px] font-extrabold text-text-primary">الأكثر مشاهدة · فكرة وحدة بكل مقطع</p>
            <a href={`${CHANNEL.url}/shorts`} target="_blank" rel="noopener noreferrer" className={link + " shrink-0"}>كل المقاطع ←</a>
          </div>
          <div className="mt-4 flex snap-x snap-mandatory gap-3 overflow-x-auto px-5 pb-2 [scrollbar-width:none] lg:grid lg:grid-cols-5 lg:overflow-visible [&::-webkit-scrollbar]:hidden">
            {TOP_SHORTS.map((v) => (
              <VideoCard key={v.id} video={v} label="فيديو قصير" className="h-[302px] w-[170px] snap-start lg:aspect-[9/16] lg:h-auto lg:w-auto" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function LongRow({ video }: { video: HomeVideo }) {
  const { play } = useVideoPlayer();
  return (
    <button
      type="button"
      onClick={() => play(video)}
      aria-label={`تشغيل الفيديو: ${video.title}`}
      className="lift flex w-full items-center gap-3 rounded-ds-lg border border-hairline-subtle bg-surface p-2.5 text-start shadow-sm"
    >
      <span className="relative h-[82px] w-[128px] shrink-0 overflow-hidden rounded-[14px] bg-ink">
        <img src={thumbUrl(video)} ref={thumbRef} onLoad={onThumbLoad} alt="" loading="lazy" width={128} height={82} className="h-full w-full object-cover" />
        <span className="absolute bottom-1.5 start-1.5 rounded-ds-pill px-2 py-0.5 text-[13px] text-cream-50" style={{ background: "rgba(17,15,13,.6)" }}>
          <bdi dir="ltr">{video.duration}</bdi>
        </span>
      </span>
      <span className="min-w-0">
        <span className="line-clamp-2 font-display text-[15px] font-bold leading-snug text-text-primary">{video.title}</span>
        <span className="mt-1 block text-[13px] text-text-secondary">{formatViewsAr(video.views)} مشاهدة</span>
      </span>
    </button>
  );
}
